import NotificationIcon from "@/public/assets/ic_notification.svg";
import Logo from "@/public/assets/logo.svg";
import LogoBlack from "@/public/assets/logo-black.svg";
import SearchIcon from "@/public/assets/ic-search.svg";
import SearchIconBlack from "@/public/assets/ic-search-black.svg";
import Image from "next/image";
import { useEffect, useState } from "react";
import BlogsSearchModal from "../search-modal/BlogsSearchModal";
import SubscibeModal from "../subscribe-modal/SubscribeModal";
import styles from "./BlogNavbar.module.scss";
import Link from "next/link";
import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { blogHeaderRedux } from "@/app/store/blog-header/reducers";
import { envConfig } from "@/envConfig";

const BlogNavbar = ({ navbarType }) => {
  const isSmallerScreen = useMediaQuery("(max-width: 500px)");
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [openSubscribeModal, setOpenSubscribeModal] = useState(false);
  const dispatch = useDispatch();
  const closeSubscribeModel = () =>
    dispatch(blogHeaderRedux.actions.closeSubscribeModel());

  const isGlobalSubscribeModelOpen = useSelector(
    (state) => state?.blogHeader?.openSubscribeModal
  );

  const handleToggleSearchModal = () => {
    setOpenSearchModal(!openSearchModal);
  };

  const handleToggleSubscribeModal = () => {
    setOpenSubscribeModal(!openSubscribeModal);
  };

  const handleCloseSubscribeModal = () => {
    setOpenSubscribeModal(false);
    if (isGlobalSubscribeModelOpen) {
      closeSubscribeModel();
    }
  };

  useEffect(() => {
    if (isGlobalSubscribeModelOpen) {
      setOpenSubscribeModal(true);
    }
  }, [isGlobalSubscribeModelOpen]);

  return (
    <>
      <div
        className={
          navbarType === "details"
            ? styles.detailNavbarWrapper
            : styles.navbarWrapper
        }
      >
        <Link
          href={
            envConfig.ENV_TYPE === "development"
              ? "https://website-stage.simpleenergy.in"
              : "https://www.simpleenergy.in"
          }
        >
          <Image
            src={navbarType === "details" ? LogoBlack : Logo}
            alt={"Logo"}
            style={{
              marginTop: "5px",
              height: isSmallerScreen ? "30px" : "40px",
            }}
            width={isSmallerScreen ? 120 : 150}
          />
        </Link>

        <div className={styles.actionsWrapper}>
          <button onClick={handleToggleSearchModal}>
            <Image
              src={
                navbarType === "details" ? SearchIconBlack.src : SearchIcon.src
              }
              alt={"Search"}
              width={20}
              height={20}
            />
          </button>

          {/* <button
            onClick={handleToggleSubscribeModal}
            className={styles.notificationBtn}
          >
            <Image
              src={NotificationIcon.src}
              alt={"Search"}
              width={isSmallerScreen ? 110 : 15}
              height={isSmallerScreen ? 110 : 15}
            />
          </button> */}

          <button
            onClick={handleToggleSubscribeModal}
            className={styles.subscribeBtn}
          >
            SUBSCRIBE
          </button>
        </div>
      </div>

      {openSearchModal && (
        <BlogsSearchModal
          open={openSearchModal}
          onClose={handleToggleSearchModal}
        />
      )}

      {/* {openSubscribeModal && ( */}
      <SubscibeModal
        open={openSubscribeModal}
        onClose={handleCloseSubscribeModal}
      />
      {/* )} */}
    </>
  );
};

export default BlogNavbar;
